import { render, staticRenderFns } from "./road-list.vue?vue&type=template&id=2f1407b4&scoped=true"
import script from "./road-list.vue?vue&type=script&lang=js"
export * from "./road-list.vue?vue&type=script&lang=js"
import style0 from "./road-list.vue?vue&type=style&index=0&id=2f1407b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1407b4",
  null
  
)

export default component.exports